<ng-container *transloco="let t">
  @if (isOpen()) {
    <ld-base-modal
      [title]="remainingLoans() === 1 ? t('modalsTcpaAdditionalLoanTitleOne') : t('modalsTcpaAdditionalLoanTitleOther')"
      [size]="'medium'"
      [showCloseButton]="true"
      [closeOnBackdropClick]="false"
      [isLoading]="isLoading()"
      [ariaLabelledBy]="'tcpa-additional-loan-modal-title'"
      (closeModal)="onClose()"
    >
      <div modal-content>
        <div id="tcpa-additional-loan-modal-icon" class="flex justify-center mb-4">
          <mat-icon class="text-5xl! text-ld-primary">home</mat-icon>
        </div>

        <p id="tcpa-additional-loan-modal-message" class="font-dm text-sm text-ld-neutral-500 text-center m-0">
          {{
            remainingLoans() === 1
              ? t('modalsTcpaAdditionalLoanSuccessMessageOne')
              : t('modalsTcpaAdditionalLoanSuccessMessageOther')
          }}
        </p>
      </div>

      <div modal-footer>
        <button
          id="tcpa-additional-loan-modal-continue-btn"
          type="button"
          class="btn-primary-ld-purple"
          [disabled]="isLoading()"
          (click)="onContinue()"
        >
          @if (isLoading()) {
            <mat-spinner diameter="16" class="w-4! h-4!"></mat-spinner>
          }
          {{ t('commonButtonsContinue') }}
        </button>
      </div>
    </ld-base-modal>
  }
</ng-container>
